import { render, staticRenderFns } from "./formEditFlowCategory.vue?vue&type=template&id=c97d24a4&"
import script from "./formEditFlowCategory.vue?vue&type=script&lang=js&"
export * from "./formEditFlowCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports